<template>
  <tr>
    <td class="text-center p-3">
      <strong style="font-size: 16px">{{
        $t('common_words.total_mayus')
      }}</strong>
    </td>
    <template v-for="(ribbonData, week) in columns">
      <template v-for="ribbon in ribbonData">
        <td class="text-center">
          <strong style="font-size: 16px">
            {{ getTotalColumn(week, ribbon) }}
          </strong>
        </td>
      </template>
    </template>
    <td class="text-center">
      <strong style="font-size: 16px">{{ getTotal() }}</strong>
    </td>
  </tr>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'tfoot-totals-by-age-week',
  props: {
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'reportByAgeAndWeek',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getTotalColumn(week, ribbon) {
      const result = Object.values(
        this.totalColumns['cutting'][week][ribbon.color_name]
      ).map((totalColumn) =>
        Array.isArray(totalColumn)
          ? getSumOfValorFromArray(totalColumn)
          : totalColumn
      );

      const sum = getSumOfValorFromArray(result);
      return sum > 0 ? Formatter.formatNumber(sum) : '';
    },
    getTotal() {
      let total = 0;
      Object.values(this.totalColumns['cutting'])
        .map((totalColumn) => Object.values(totalColumn))
        .forEach((values) => {
          values.forEach((items) => {
            const v = Object.values(items);
            total += Array.isArray(v) ? getSumOfValorFromArray(v) : items;
          });
        });

      return total > 0 ? Formatter.formatNumber(total) : '';
    },
  },
};
</script>
